import { createRoot } from "react-dom/client";
import { App } from "./App";
import { FlowTraceIntlProvider } from "./i18n";
import {
  FlowTraceFrontendErrorBoundary,
  installFlowTraceFrontendIncidentReporter,
} from "./lib/frontend-incidents";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root element");

installFlowTraceFrontendIncidentReporter();

createRoot(root).render(
  <FlowTraceFrontendErrorBoundary>
    <FlowTraceIntlProvider>
      <App />
    </FlowTraceIntlProvider>
  </FlowTraceFrontendErrorBoundary>,
);
